import React from 'react';
import Item from '@app/components/item';
import { ItemDto } from '@app/models/dtos/strapi';

function OurValues({ ourValues }: { ourValues: Array<ItemDto> }) {
    return (
        <div className="my-[80px] flex w-full flex-col items-center md:my-[160px]">
            <div className="container w-full">
                <p className="P2  !text-black-1 ">Our Values</p>
                <div className="mt-[20px] grid grid-flow-row grid-cols-1 gap-[45px] sm:grid-cols-2 md:mt-[40px] lg:grid-cols-3">
                    {ourValues.map((item) => (
                        <Item key={item.id} item={item} />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default OurValues;
